import { fromJS, Map } from "immutable";
import { GenericActions } from "../../redux/generic-actions";
import { componentsReducer } from "../../redux/root.reducer";
import { DataListActions } from "./actions.types";

export function commonListReducers(state, action, initialState, rootProp) {
    state = componentsReducer(rootProp, state, action);
    state = listActionReducer(state, action, initialState, rootProp);
    state = paramsActionReducer(state, action, initialState, rootProp);
    state = toggleDisplayActionReducer(state, action, initialState, rootProp);
    state = permissionDenied(state, action, rootProp, initialState);
    return state;
}

export function incrementOffset(state, data, stateProp) {
    const dataLength = !!data ? data.count() : 0;
    const params = state.getIn([stateProp, "listData", "params"]) || Map();
    return params.set("offset", dataLength);
}

export function listActionReducer(state, action, initialState, rootProp) {
    let results;
    switch (action.type) {
        case `${rootProp}::${DataListActions.LIST_LOADED}`:
            results = fromJS(action.payload);
            return state.mergeIn([action.stateProp, "listData"], {
                results,
                isExhausted: false,
                params: incrementOffset(state, results, action.stateProp),
            });
        case `${rootProp}::${DataListActions.LIST_PAGINATED}`:
            results = state.getIn([action.stateProp, "listData", "results"]).concat(action.payload);
            const params = incrementOffset(state, results, action.stateProp);
            return state.mergeIn([action.stateProp, "listData"], { results, params });

        case `${rootProp}::${DataListActions.LIST_EXHAUSTED}`:
            return state.setIn([action.stateProp, "listData", "isExhausted"], true);

        default:
            return state;
    }
}

export function paramsActionReducer(state, action, initialState, rootProp) {
    switch (action.type) {

        case `${rootProp}::${DataListActions.PARAMS_UPDATED}`:
            return state.mergeIn([action.stateProp, "listData", "params"], action.payload);

        case `${rootProp}::${DataListActions.PARAMS_OFFSET_RESET}`:
            return state.setIn([action.stateProp, "listData", "params", "offset"], 0);

        case `${rootProp}::${DataListActions.PARAMS_REMOVED}`:
            action.payload.forEach((paramToRemove) => state = state.deleteIn([action.stateProp, "listData", "params", paramToRemove]));
            return state;

        default:
            return state;
    }
}

export function toggleDisplayActionReducer(state, action, initialState, rootProp) {
    switch (action.type) {
        case `${rootProp}::${GenericActions.DISPLAY_TOGGLED}`:
            const existingVisibility = state.getIn([action.stateProp, "listData", "expandedRows", action.payload]) || false;
            state = state.setIn([action.stateProp, "listData", "expandedRows", action.payload], !existingVisibility);

            const numberOfExpandedRows = state.getIn([action.stateProp, "listData", "expandedRows"]).filter((expanded) => !!expanded).count();
            state = state.setIn([action.stateProp, "listData", "numberOfExpandedRows"], numberOfExpandedRows);
            return state;
        default:
            return state;
    }
}

function permissionDenied(state, action, rootProp, initialState) {
    if (action.type.includes(GenericActions.PERMISSION_DENIED)) {
        return state.setIn([action.stateProp, "formValidation", "errors"]);
    } else {
        return state;
    }
}
